<app-entity-complaints [entityType]="sharedService.testingLab"></app-entity-complaints>
